<template>
    <div class="user-component">
        <div class="user-body">
            <table id="student-progress" class="table"
                responsive="sm"
                show-empty
                small
            >
                <thead>
                    <tr >
                        <th class="t-column-header">Nama Mata Pelajaran</th>
                        <th class="t-column-header">Nilai</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in detail" :key="index">
                        <td class="t-column-body">{{item.subject_name}}</td>
                        <td class="t-column-body">{{item.subject_value}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/eventBus.js'
    export default {
        props: {
            detail: {
               type: Array,
                default () {
                    return [{}]
                }
            }
        },
        components: {
            
        },
        data() {
            return {
                showLoader: false,
            };
        },
        methods: {
            hideFormModal() {
                EventBus.$emit('hideFormModal', true)
            },
        },
		created () {
			//
        }
    }
</script>